import { Model } from "@vuex-orm/core"
import Photo from "./Photo"

export default class Album extends Model {
  static entity = "albums"

  static fields() {
    return {
      id: this.string(""),
      year: this.string(""),
      date: this.string(""),
      folder: this.string(""),
      heading: this.string(""),
      data: this.attr([])
    }
  }

  id!: string
  year!: string
  date!: string
  folder!: string
  heading!: string[]
  data!: Photo[]
}
